// sendToCosmos.js


export const SendToCosmos = async (payload) => {
  try {
    console.log('SendToCosmos_payload',payload)
		//con-concierge-file
    //con-concierge-hist 
//    payload.container="con-concierge-file"
    //console.log('SendToCosmos_payload',payload) 

    const response = await fetch(`${process.env.REACT_APP_CROSPRO2_URL}?code=${process.env.REACT_APP_CROSPRO2_KEY}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', 
      },
      body: JSON.stringify(payload),
      //keepalive: true, // 重要！
    });
    // レスポンスの確認
    if (response.ok) {
      return true;
    } 

  } catch (error) {
      console.log('SendToCosmosErr:',error)
      throw error;
  }
};

export const LoadToCosmos = async (payload) => {
  console.log('LoadToCosmos_payload',payload)
  let query;

  switch (payload.container) {
  case 'con-concierge-hist':
    if (payload.compId) {
      query = `id=${payload.compId}-${payload.userId}&container=${payload.container}&`
    } else {
      query = `id=${payload.userId}&container=${payload.container}&`
    }
    break;
  case 'con-concierge-user':

    switch (payload.id) {
    case 'all':
        query = `id=${payload.id}&container=${payload.container}&`
        break;
    case 'sso':
        query = `id=${payload.id}&userId=${payload.userId}&container=${payload.container}&`
        break; 
    default:
        query = `id=${payload.compId}-${payload.userId}&container=${payload.container}&`
        break;  
    }
    break;
  case 'con-concierge-file'://CompIdが顧客ID　キー
    switch (payload.id) {
    case 'all':
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    case 'bu':
      query = `id=${payload.id}&bu=${payload.bu}&container=${payload.container}&`
      break;
    default:
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    }
    break;
  case 'con-concierge-filebu':
    query = `id=${payload.id}&container=${payload.container}&`
    //console.log('con-concierge-filebu_query',query)
    break;
  case 'con-concierge-filebutrk':
    query = `id=${payload.id}&container=${payload.container}&`
    //console.log('con-concierge-filebutrk_query',query)
    break;
  case 'con-concierge-filebunew':
    query = `id=${payload.id}&container=${payload.container}&`
    //console.log('con-concierge-filebu_query',query)
    break;
  case 'con-concierge-filebutrknew':
    query = `id=${payload.id}&container=${payload.container}&`
    //console.log('con-concierge-filebutrk_query',query)
    break;
  case 'con-concierge-prompt'://CompIdが顧客ID　キー
    if(payload.id==='all'){
      query = `id=${payload.id}&container=${payload.container}&`
      //console.log('query',query)
      break;
    }else{
      query = `id=${payload.compId}&container=${payload.container}&`
      //console.log('query',query)
      break;      
    }
  case 'con-concierge-request':
    if(payload.id === 'all'){
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    } else {
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    }
  case 'con-concierge-reqaction':
    if(payload.id === 'all'){
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    } else {
      query = `id=${payload.id}&container=${payload.container}&`
      break;
    }
  case 'con-concierge-knowledge':
    // 質問履歴ダウンロード用：日付範囲・compId条件付き
    query = `id=${payload.id}&container=${payload.container}`
    if (payload.dateFrom) query += `&dateFrom=${payload.dateFrom}`
    if (payload.dateTo) query += `&dateTo=${payload.dateTo}`
    if (payload.compId) query += `&compId=${payload.compId}`
    query += `&`
    break;
  case 'conversations02':
    // ナレッジ/FAQ/ルール登録用：type条件付き
    query = `id=${payload.id}&container=${payload.container}&type1=${payload.type1}&type2=${payload.type2}&`
    break;
  default:
    query = `id=${payload.id}&container=${payload.container}&`
    break;
  }
  
  try {
    
    const response = await fetch(`${process.env.REACT_APP_CROSPRO2_URL}?${query}code=${process.env.REACT_APP_CROSPRO2_KEY}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        keepalive: true,
      }
    );

    const data = await response.json();
    console.log('取得したデータ:', data);
    return data;

  } catch (error) {
    console.error("CosmosDBの読み込みエラー:", error);
    return null;
  }
};

export const DeleteToCosmos  = async (payload) => {
  console.log('DeleteToCosmos_payload',payload)

  try {
    const response = await fetch(`${process.env.REACT_APP_CROSPRO2_URL}?code=${process.env.REACT_APP_CROSPRO2_KEY}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    // レスポンスの確認
    if (response.ok) {
      return "削除しました。"
    } else {
      const errorData = await response.json();
      console.error(`削除に失敗しました: ${errorData.message}`);
      return "削除に失敗しました。"
    }
  } catch (error) {
    console.error("エラーが発生しました:", error);
    return "削除に失敗しました。"
  }

};